/* Fithome: ventana de cesta al añadir un producto (solo ordenador, >= 990px).
   Dura 3 segundos (se queda abierta mientras el ratón está encima) y se cierra con la cruz.
   Muestra: "Cesta (n.º de artículos en la cesta)", el producto añadido (foto, nombre, opción, precio,
   descripción corta) y "Total (unidades añadidas)" con su importe, + botón "Ver cesta".
   - Ficha de producto: se engancha a la petición jQuery a /cart/add.js de layout/theme.liquid.
   - Tarjetas y otros añadidos por fetch a /cart/add: se detectan envolviendo window.fetch.
   Mientras está abierta se oculta el mensaje pequeño (.toast) de la cabecera. En móvil no se usa
   y sigue saliendo el .toast. Se carga en todas las páginas desde snippets/chat-bubble.liquid. */
(function () {
  if (window.fhCartPopup) return;

  var LANG = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'es').slice(0, 2);
  var TX = {
    es: { cart: 'Cesta', total: 'Total', unit: 'ud.', view: 'Ver cesta', close: 'Cerrar', tag: 'es-ES' },
    ca: { cart: 'Cistella', total: 'Total', unit: 'u.', view: 'Veure la cistella', close: 'Tanca', tag: 'ca-ES' },
    en: { cart: 'Basket', total: 'Total', unit: 'pcs', view: 'View basket', close: 'Close', tag: 'en-GB' }
  };
  var t = TX[LANG] || TX.en;

  function isDesktop() { return window.innerWidth >= 990; }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || root() + 'cart'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, currency) {
    var v = (cents || 0) / 100;
    /* Euros: mismo formato que las tarjetas y la ficha (snippets/fh-money.liquid): 72,50 € / 1.580 € */
    if (!currency || currency === 'EUR') {
      var c = Math.round(Math.abs(cents || 0));
      var ints = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var dec = c % 100;
      return ((cents || 0) < 0 ? '-' : '') + ints + (dec ? ',' + (dec < 10 ? '0' : '') + dec : '') + ' €';
    }
    try {
      var o = { style: 'currency', currency: currency || 'EUR' };
      if (v % 1 === 0) { o.minimumFractionDigits = 0; o.maximumFractionDigits = 0; }
      return new Intl.NumberFormat(t.tag, o).format(v);
    } catch (e) {
      return v.toFixed(2).replace('.', ',') + ' ' + (currency || '€');
    }
  }
  function shortText(html, max) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var s = (d.textContent || '').replace(/\s+/g, ' ').trim();
    if (s.length > max) s = s.slice(0, max).replace(/\s+\S*$/, '') + '…';
    return s;
  }
  function img(url, w) {
    if (!url || /^data:/.test(url)) return url || '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var el = null, timer = null, hovering = false;
  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'fh-cp';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-live', 'polite');
    var toast = document.querySelector('.toast');
    if (toast && toast.parentNode) {
      toast.parentNode.insertBefore(el, toast.nextSibling);
    } else {
      el.classList.add('fh-cp--fixed');
      document.body.appendChild(el);
    }
    el.addEventListener('mouseenter', function () { hovering = true; clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    document.addEventListener('click', function (e) {
      if (el.classList.contains('is-open') && !el.contains(e.target) && !(e.target.closest && e.target.closest('[data-fh-cg]'))) hide();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    el.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fh-cp-close]')) { e.preventDefault(); hovering = false; clearTimeout(timer); hide(); }
    });
    return el;
  }
  function hide() {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.classList.remove('fh-cp-active');
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { if (!hovering) hide(); }, 3000);
  }

  function render(item, qty, cart) {
    var box = build();
    var variant = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      var opts = item.options_with_values || [];
      variant = opts.length ? opts.map(function (o) { return o.name + ': ' + o.value; }).join(' · ') : item.variant_title;
    }
    var unitPrice = item.final_price != null ? item.final_price : item.price;
    var currency = (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var count = cart && cart.item_count != null ? cart.item_count : qty;
    var desc = shortText(item.product_description, 120);
    box.innerHTML =
      '<button type="button" class="fh-cp__close" data-fh-cp-close aria-label="' + esc(t.close) + '">&times;</button>' +
      '<div class="fh-cp__head">' + esc(t.cart) + ' <span>(' + count + ')</span></div>' +
      '<div class="fh-cp__item">' +
        (item.image ? '<a href="' + esc(item.url || cartUrl()) + '" class="fh-cp__img-link"><img class="fh-cp__img" src="' + esc(img(item.image, 240)) + '" alt="' + esc(item.product_title || '') + '"></a>' : '') +
        '<div class="fh-cp__info">' +
          '<div class="fh-cp__row"><a class="fh-cp__title" href="' + esc(item.url || cartUrl()) + '">' + esc(item.product_title || item.title || '') + '</a>' +
          '<span class="fh-cp__price">' + esc(money(unitPrice, currency)) + '</span></div>' +
          (variant ? '<div class="fh-cp__variant">' + esc(variant) + '</div>' : '') +
          (desc ? '<div class="fh-cp__desc">' + esc(desc) + '</div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="fh-cp__total"><span>' + esc(t.total) + ' <small>(' + qty + ' ' + esc(t.unit) + ')</small></span>' +
      '<span>' + esc(money(unitPrice * qty, currency)) + '</span></div>' +
      '<a class="fh-cp__btn" href="' + esc(cartUrl()) + '">' + esc(t.view) + '</a>';
    document.body.classList.add('fh-cp-active');
    box.classList.remove('is-open');
    void box.offsetWidth;
    box.classList.add('is-open');
    schedule();
  }

  /* item: línea devuelta por /cart/add.js; qty: unidades añadidas. Devuelve false si no aplica (móvil). */
  function show(item, qty) {
    if (!isDesktop() || !item) return false;
    qty = parseInt(qty, 10) || 1;
    document.body.classList.add('fh-cp-active');
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(item, qty, cart); })
      .catch(function () { render(item, qty, null); });
    return true;
  }
  window.fhCartPopup = { show: show, hide: hide };

  /* Ficha de producto: petición jQuery de layout/theme.liquid */
  function hookJQuery() {
    var $ = window.jQuery;
    if (!$ || hookJQuery.done) return;
    hookJQuery.done = true;
    $(document).ajaxSuccess(function (e, xhr, s) {
      if (!s || !s.url || String(s.url).indexOf('/cart/add') < 0) return;
      var resp = xhr.responseJSON;
      if (!resp) { try { resp = JSON.parse(xhr.responseText); } catch (err) { return; } }
      var item = resp && resp.items ? resp.items[0] : resp;
      var qty = 1;
      try {
        if (typeof s.data === 'string') {
          var p = new URLSearchParams(s.data);
          qty = parseInt(p.get('items[0][quantity]') || p.get('quantity'), 10) || 1;
        } else if (s.data && s.data.items && s.data.items[0]) {
          qty = parseInt(s.data.items[0].quantity, 10) || 1;
        }
      } catch (err) {}
      show(item, qty);
    });
  }
  /* Tarjetas y cualquier otro añadido por fetch a /cart/add (fh-card-gallery.js, product-form.js) */
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(window, arguments);
      if (String(url).indexOf('/cart/add') > -1 && isDesktop()) {
        var qty = 1;
        try {
          var b = init && init.body;
          if (typeof b === 'string') {
            var j = JSON.parse(b);
            qty = (j.items && j.items[0] && j.items[0].quantity) || j.quantity || 1;
          } else if (window.FormData && b instanceof FormData) {
            qty = parseInt(b.get('quantity'), 10) || 1;
          }
        } catch (err) {}
        document.body.classList.add('fh-cp-active');
        p.then(function (r) {
          if (!r.ok) { document.body.classList.remove('fh-cp-active'); return; }
          r.clone().json().then(function (d) {
            show(d && d.items ? d.items[0] : d, qty);
          }).catch(function () { document.body.classList.remove('fh-cp-active'); });
        }).catch(function () { document.body.classList.remove('fh-cp-active'); });
      }
      return p;
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookJQuery);
  else hookJQuery();
  window.addEventListener('load', hookJQuery);
})();

/* Fithome: el país de la cabecera y del pie de página muestra el país REAL con el que Shopify está
   vendiendo (Shopify.country), no el último que se pulsó en la ventana de bienvenida (que se guardaba
   en el navegador aunque no se confirmara y podía decir "Estados Unidos" comprando en España). */
(function () {
  function syncCountry() {
    var code = ((window.Shopify && window.Shopify.country) || '').toLowerCase();
    if (!code) return;
    var opts = document.querySelectorAll('[data-country-code][data-country]');
    var match = null;
    for (var i = 0; i < opts.length; i++) {
      if ((opts[i].getAttribute('data-country-code') || '').toLowerCase() === code) { match = opts[i]; break; }
    }
    if (!match) return;
    var name = (match.getAttribute('data-country') || '').trim();
    if (!name) return;
    try { if (localStorage.getItem('akSelectedCountry_') !== name) localStorage.setItem('akSelectedCountry_', name); } catch (e) {}
    document.querySelectorAll('.ak-header-currency-lang-center a, .footer-globe span.int, .footer-selected-country').forEach(function (el) {
      if (el.textContent.trim() !== name) el.textContent = name;
    });
  }
  [0, 600, 1500, 3000, 6000].forEach(function (t) { setTimeout(syncCountry, t); });
  window.addEventListener('load', syncCountry);
})();
